"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPaginationButton = void 0;
var _PaginationButton = require("./PaginationButton");
// TODO: in v9, move styled() from PaginationButton.jsx to here
var StyledPaginationButton = _PaginationButton.PaginationButton;
exports.StyledPaginationButton = StyledPaginationButton;